import { TenantResDto } from '@/types';
import { useMemo } from 'react';
import { matchPath, matchRoutes, useLocation } from 'react-router-dom';

// 存储所有路由配置
export let allRoutes: RouteConfig[] = [];

export const setAllRoutes = (routes: RouteConfig[]) => {
  allRoutes = routes;
};

/**
 * 获取当前路由的元数据（例如标题、权限等）
 */
export const useCurrentRouteMeta = () => {
  const location = useLocation();

  return useMemo(() => {
    const matches = matchRoutes(allRoutes, location);
    if (!matches || matches.length === 0) return null;

    // 获取当前匹配的路由（通常是最后一个）
    const currentRoute = matches[matches.length - 1].route;
    return currentRoute.meta || {};
  }, [location]);
};

export interface BreadcrumbItem {
  title: string;
  path: string;
  isCurrent?: boolean;
}

/**
 * 面包屑导航
 * @returns
 */
export const useBreadcrumb = (): BreadcrumbItem[] => {
  const location = useLocation();

  return useMemo(() => {
    const breadcrumbs: BreadcrumbItem[] = [];

    // 构建面包屑路径
    let currentPath = '';

    const pathSegments = location.pathname.split('/').filter((segment) => segment !== '');

    pathSegments.forEach((segment) => {
      currentPath += `/${segment}`;
      // 查找匹配的路由配置
      const matchedRoute = findMatchingRoute(currentPath, allRoutes);
      if (matchedRoute) {
        // 避免重复添加相同的面包屑
        const isDuplicate = breadcrumbs.findIndex(
          (item) => item.path === matchedRoute.path || item.title === matchedRoute.name,
        );

        if (isDuplicate >= 0) {
          breadcrumbs.splice(isDuplicate, 1, {
            path: matchedRoute.pathname || matchedRoute.path,
            title: matchedRoute.name || matchedRoute.meta?.title || '-',
          });
        } else {
          breadcrumbs.push({
            path: matchedRoute.pathname || matchedRoute.path,
            title: matchedRoute.name || matchedRoute.meta?.title || '-',
          });
        }
      }
    });

    return breadcrumbs;
  }, [location]);
};

/**
 * 查找匹配路由
 * @param path
 * @param routes
 * @returns
 */
export const findMatchingRoute = (path: string, routes: RouteConfig[] = allRoutes): any => {
  // 1. 精确匹配优先
  const exactMatch = routes.find((route) => route.path === path);
  if (exactMatch) return exactMatch;
  // 2. 参数匹配
  for (const route of routes) {
    if (route.path.includes(':') && path) {
      const match = matchPath(route.path, path);
      if (match) {
        return { ...match, ...route };
      }
    }
  }

  // 3. 递归查找子路由
  for (const route of routes) {
    if (route.children) {
      const childMatch = findMatchingRoute(path, route.children);
      if (childMatch) {
        return childMatch;
      }
    }
  }

  return null;
};

export const byAuthorityKeyFindRoute = (path: string, routes: RouteConfig[] = allRoutes): any => {
  // 1. 精确匹配优先
  const exactMatch = (routes as TenantResDto[]).find((route) => route.authorityKey === path);
  if (exactMatch) return exactMatch;
  // // 3. 递归查找子路由
  for (const route of routes) {
    if (route.children) {
      const childMatch = byAuthorityKeyFindRoute(path, route.children);
      if (childMatch) {
        return childMatch;
      }
    }
  }

  return null;
};
